import { IconPropTypes } from '@/legacy/types';

const CloseIcon = (props: IconPropTypes) => {
	const { width, height, className } = props;
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width || 16}
			height={height || 16}
			viewBox='0 0 16 16'
			fill='none'
			className={className}
		>
			<path
				stroke={props.color || 'currentColor'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={1.5}
				d='m3 3 10 10M3 13 13 3'
			/>
		</svg>
	);
};

export default CloseIcon;
